import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { DataGrid } from '@mui/x-data-grid';
import api from '../api';

export default function LogList() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [relatedType, setRelatedType] = useState('');
  const [keyword, setKeyword] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [hideTargetId, setHideTargetId] = useState(null);

  const loadLogs = async () => {
    setLoading(true);
    const params = {};
    if (relatedType) params.related_type = relatedType;
    if (keyword) params.keyword = keyword;
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    try {
      const res = await api.get('/api/logs', { params });
      setLogs(res.data.logs || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadLogs(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // xlsx 行50: 物理削除はせず hidden フラグで論理削除
  const confirmHide = async () => {
    try {
      await api.patch(`/api/logs/${hideTargetId}/hide`);
      setHideTargetId(null);
      loadLogs();
    } catch (e) {
      alert(`非表示にできませんでした: ${e.response?.data?.error || e.message}`);
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'relatedType', headerName: '種別', width: 110 },
    { field: 'relatedId', headerName: '関連ID', width: 100 },
    { field: 'action', headerName: 'アクション', width: 120 },
    { field: 'operatedBy', headerName: '担当者', width: 120 },
    {
      field: 'operatedAt',
      headerName: '日時',
      width: 170,
      valueFormatter: ({ value }) => value ? String(value).replace('T', ' ').slice(0, 19) : '',
    },
    { field: 'oldValue', headerName: '変更前', width: 150 },
    { field: 'newValue', headerName: '変更後', width: 150 },
    {
      field: 'actions',
      headerName: '',
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (p) => (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', height: '100%' }}>
          <Tooltip title="このログを非表示にする">
            <IconButton size="small" onClick={() => setHideTargetId(p.row.id)}>
              <VisibilityOffIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
        <TextField label="種別" value={relatedType} onChange={e => setRelatedType(e.target.value)} size="small" />
        <TextField label="キーワード" value={keyword} onChange={e => setKeyword(e.target.value)} size="small" />
        <TextField label="開始日" type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
        <TextField label="終了日" type="date" value={toDate} onChange={e => setToDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
        <Button variant="contained" onClick={loadLogs}>検索</Button>
      </Box>
      <DataGrid
        rows={logs}
        columns={columns}
        autoHeight
        initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
        pageSizeOptions={[20, 50, 100]}
        loading={loading}
        getRowId={row => row.id}
        disableRowSelectionOnClick
      />

      <Dialog open={Boolean(hideTargetId)} onClose={() => setHideTargetId(null)}>
        <DialogTitle>ログを非表示にする</DialogTitle>
        <DialogContent>
          選択したログを一覧から非表示にします。データは保持され、物理削除はされません。
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHideTargetId(null)}>キャンセル</Button>
          <Button variant="contained" color="warning" onClick={confirmHide}>
            非表示にする
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
